// extracted by mini-css-extract-plugin
export default {"container":"ResultadosP_container__e+Atl","conteudo":"ResultadosP_conteudo__jrONJ","desc":"ResultadosP_desc__CPf-P"};